module.exports = __webpack_public_path__ + "media/location-service_de_ipad_new.700cb1e3.mp4";